import * as React from "react";
import { PureComponent } from "react";
import "./style.scss";
import AppContext from "../../context/AppContext";

class MenuToggler extends PureComponent {
  static contextType = AppContext;

  handleClick = () => {
    const { toggleShowMenu } = this.context;
    toggleShowMenu();
  };

  render() {
    return (
      <button className="material-icons MenuToggler" onClick={this.handleClick}>
        menu
      </button>
    );
  }
}

export default MenuToggler;
